import { render, staticRenderFns } from "./TransData.vue?vue&type=template&id=7a98290f&scoped=true"
import script from "./TransData.vue?vue&type=script&lang=js"
export * from "./TransData.vue?vue&type=script&lang=js"
import style0 from "./TransData.vue?vue&type=style&index=0&id=7a98290f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a98290f",
  null
  
)

export default component.exports